import { render } from "./MidCard.vue?vue&type=template&id=534635bb&scoped=true"
import script from "./MidCard.vue?vue&type=script&lang=js"
export * from "./MidCard.vue?vue&type=script&lang=js"

import "./MidCard.vue?vue&type=style&index=0&id=534635bb&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534635bb"]])

export default __exports__